var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { deleteDoc, deleteField, doc, getDoc, setDoc, updateDoc, arrayRemove, arrayUnion, runTransaction, writeBatch, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { deleteUser, EmailAuthProvider, getAuth, reauthenticateWithCredential, sendPasswordResetEmail } from "firebase/auth";
import { collection, getDocs, query, where, limit as limitFS } from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';
import { convertBackChannelToClient, createBaseMessageObject, createBaseObjectChannel, createChatList, createObjectChannel, createObjectUser, generateShortId, getChatType, getFakeChat, makeChatId } from "../utils/utils";
import { firebasePath, clickType } from "../constants/constants";
import pLimit from "p-limit";
const CONCURRENCY_LIMIT = 3;
const limit = pLimit(CONCURRENCY_LIMIT);
export const profileAPI = {
    createNewUserInDB(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseName = user.email.slice(0, user.email.indexOf('@')).toLowerCase();
            const isFreeName = yield profileAPI.checkDisplayName(baseName);
            let displayName = baseName;
            if (!isFreeName) {
                displayName = `${baseName}_${generateShortId(6)}`;
            }
            const userObj = {
                email: user.email,
                displayName,
                uid: user.uid,
                registrationDate: new Date().toLocaleDateString()
            };
            yield setDoc(doc(db, firebasePath.USERS, user.uid), userObj);
            return userObj;
        });
    },
    changeUserInfo(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const userRef = doc(db, firebasePath.USERS, data.uid);
            yield updateDoc(userRef, {
                photoURL: data.photoURL,
                displayName: data.displayName
            });
        });
    },
    getCurrentInfo(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            const userRef = doc(db, firebasePath.USERS, uid);
            const docSnap = yield getDoc(userRef);
            if (docSnap.exists()) {
                const info = docSnap.data();
                return info;
            }
            else {
                return null;
            }
        });
    },
    updateUserInMyChatList(email, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, email, firebasePath.CHATLIST);
            yield setDoc(ref, { [user.uid]: user }, { merge: true });
        });
    },
    deleteUserAndData(password) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = getAuth();
            const user = auth.currentUser;
            const credential = EmailAuthProvider.credential(user.email, password);
            if (!user) {
                console.error('Нет текущего пользователя');
                return;
            }
            try {
                yield reauthenticateWithCredential(user, credential);
                console.log('Переаутентификация успешна');
            }
            catch (err) {
                const error = err;
                console.error('Ошибка переаутентификации:', error.message);
                throw err;
            }
            try {
                const userColRef = collection(db, user.email);
                const snapshot = yield getDocs(userColRef);
                yield Promise.all(snapshot.docs.map((d) => deleteDoc(d.ref)));
                console.log(`Коллекция "${user.email}" очищена.`);
                yield deleteDoc(doc(db, firebasePath.USERS, user.uid));
                console.log('Документ пользователя удалён');
                yield deleteUser(user);
                console.log('Пользователь удалён из Firebase Auth');
            }
            catch (err) {
                console.error('Ошибка при удалении пользователя:', err);
            }
        });
    },
    deletUserInMyChatlist(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatCurrentRef = doc(db, options.myEmail, firebasePath.CHATLIST);
            yield updateDoc(chatCurrentRef, {
                [options.deleteId]: deleteField()
            });
        });
    },
    resetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = getAuth();
            try {
                yield sendPasswordResetEmail(auth, email);
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        });
    },
    checkDisplayName(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = query(collection(db, firebasePath.USERS), where("displayName", "==", value.toLowerCase()));
            const querySnapshot = yield getDocs(q);
            return querySnapshot.empty;
        });
    }
};
/**
 * @author sheva2103
 * @project EasyMessenger
 * @license MIT
 * @link https://github.com/sheva2103/easy-messenger
 * @email 2103sheva@gmail.com
 * @copyright (c) 2025 Aleksandr (GitHub: sheva2103)
 */
export const searchAPI = {
    searchUser(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const chats = [];
            const q = query(collection(db, firebasePath.USERS));
            const querySnapshot = yield getDocs(q);
            querySnapshot.forEach((doc) => {
                const displayName = doc.data().displayName.toLowerCase();
                if (displayName.includes(name.toLowerCase()))
                    chats.push(doc.data());
            });
            return chats;
        });
    },
    searchChannel(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const channels = [];
            const querySnapshot = yield getDocs(collection(db, firebasePath.CHANNELS_INFO));
            querySnapshot.forEach((doc) => {
                const displayName = doc.data().displayName.toLowerCase();
                if (displayName.includes(name.toLowerCase()))
                    channels.push(doc.data());
            });
            return channels;
        });
    }
};
export const messagesAPI = {
    addChat(user, recipient, chatID) {
        return __awaiter(this, void 0, void 0, function* () {
            const dateOfChange = JSON.stringify(new Date());
            const chat = { chatID, displayName: recipient.displayName, email: recipient.email, uid: recipient.uid, dateOfChange };
            if (recipient === null || recipient === void 0 ? void 0 : recipient.channel) {
                chat.channel = { owner: recipient.channel.owner, channelID: recipient.channel.channelID, displayName: recipient.channel.displayName, isOpen: recipient.channel.isOpen };
                chat.chatID = recipient.channel.channelID;
            }
            yield setDoc(doc(db, user.email, firebasePath.CHATLIST), { [recipient.uid]: chat }, { merge: true });
            if (recipient === null || recipient === void 0 ? void 0 : recipient.channel) {
                yield channelAPI.changeListSubscribers(clickType.ADD_TO_LIST_SUBSCRIBERS, chat.chatID, user);
            }
        });
    },
    sendMessage(chat, sender, message, isFavorites, replyToMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            const date = JSON.stringify(new Date());
            const reference = getChatType(isFavorites, chat);
            const id = uuidv4();
            const messageObj = { message: message, messageID: id, date: date, sender: Object.assign({}, sender) };
            if (!isFavorites && !(chat === null || chat === void 0 ? void 0 : chat.channel))
                messageObj.read = false;
            if (chat === null || chat === void 0 ? void 0 : chat.channel)
                messageObj.sender.channel = createBaseObjectChannel(chat.channel);
            if (replyToMessage)
                messageObj.replyToMessage = replyToMessage;
            if (chat.channel) {
                yield channelAPI.changeCannelInfo({ channel: chat.channel, updateDateOfChange: true, lastMessage: messageObj, updateLastMessage: true });
            }
            const newDocRef = doc(reference, id);
            return yield setDoc(newDocRef, messageObj, { merge: true });
        });
    },
    getChatID(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const docRef = doc(db, firebasePath.CHATS, id);
            const docSnap = yield getDoc(docRef);
            if (docSnap.exists()) {
                return id;
            }
            return null;
        });
    },
    sendEditMessage(chat, message, isFavorites) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageRef = getChatType(isFavorites, chat);
            const date = JSON.stringify(new Date());
            const docToUpdateRef = doc(messageRef, message.messageID);
            yield updateDoc(docToUpdateRef, {
                message: message.message,
                changed: date
            });
        });
    },
    deleteMessage(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { chat, message, isFavorites, updateLastMessage } = options;
            const messagesRef = getChatType(isFavorites, chat);
            const docToDeleteRef = doc(messagesRef, message.messageID);
            const channel = chat === null || chat === void 0 ? void 0 : chat.channel;
            yield deleteDoc(docToDeleteRef);
            if (isFavorites || !channel)
                return;
            if (updateLastMessage) {
                const channelRef = doc(db, firebasePath.CHANNELS_INFO, channel.channelID);
                const q = query(messagesRef, orderBy("date", "desc"), limitFS(1));
                const querySnapshot = yield getDocs(q);
                if (!querySnapshot.empty) {
                    const lastMessage = createBaseMessageObject(querySnapshot.docs[0].data());
                    yield updateDoc(channelRef, {
                        lastMessage: lastMessage,
                    });
                }
                else {
                    yield updateDoc(channelRef, {
                        lastMessage: deleteField(),
                    });
                }
            }
        });
    },
    forwardedMessageFrom(sender, recipient, message) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const id = uuidv4();
            const date = JSON.stringify(new Date());
            const forwardedFrom = ((_a = message.forwardedFrom) === null || _a === void 0 ? void 0 : _a.channel) ?
                createObjectChannel((_b = message.forwardedFrom) === null || _b === void 0 ? void 0 : _b.channel)
                :
                    ((_c = message.sender) === null || _c === void 0 ? void 0 : _c.channel) ?
                        createObjectChannel(message.sender.channel)
                        :
                            message.sender;
            const messageObj = { message: message.message, messageID: id, date, read: false, sender, forwardedFrom };
            if (message === null || message === void 0 ? void 0 : message.callStatus)
                messageObj.callStatus = message === null || message === void 0 ? void 0 : message.callStatus;
            if (message === null || message === void 0 ? void 0 : message.shareChat)
                messageObj.shareChat = message.shareChat;
            const getID = makeChatId({ currentUser: sender, guestInfo: recipient });
            const currentID = yield messagesAPI.getChatID(getID);
            if (currentID) {
                const reference = getChatType(false, getFakeChat(currentID));
                const newDocRef = doc(reference, id);
                yield setDoc(newDocRef, messageObj, { merge: true });
                yield Promise.all([messagesAPI.addChat(sender, recipient, currentID), messagesAPI.addChat(recipient, sender, currentID)]);
            }
            else {
                const reference = getChatType(false, getFakeChat(getID));
                const newDocRef = doc(reference, id);
                yield Promise.all([messagesAPI.addChat(sender, recipient, getID), messagesAPI.addChat(recipient, sender, getID)]);
                yield setDoc(newDocRef, messageObj, { merge: true });
            }
        });
    },
    readMessage(chat, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const messagesCollectionRef = getChatType(false, chat);
            const messageDocRef = doc(messagesCollectionRef, message.messageID);
            yield updateDoc(messageDocRef, {
                read: true
            });
        });
    },
    // async clearChat(chat, isFavorites) {
    //     const collectionRef = getChatType(isFavorites, chat)
    //     const querySnapshot = await getDocs(collectionRef);
    //     const messagesToDelete = querySnapshot.docs.map(doc => ({ ...doc.data() })) as MessageType[]
    //     const limitedPromises = messagesToDelete.map(message =>
    //         limit(() => messagesAPI.deleteMessage({chat, message, isFavorites}))
    //     )
    //     return Promise.all(limitedPromises);
    // },
    clearChat(chat, isFavorites) {
        return __awaiter(this, void 0, void 0, function* () {
            const collectionRef = getChatType(isFavorites, chat);
            const querySnapshot = yield getDocs(collectionRef);
            if (querySnapshot.empty)
                return;
            const docs = querySnapshot.docs;
            const batches = [];
            for (let i = 0; i < docs.length; i += 500) {
                const batch = writeBatch(db);
                const chunk = docs.slice(i, i + 500);
                chunk.forEach((document) => {
                    batch.delete(document.ref);
                });
                batches.push(batch.commit());
            }
            try {
                yield Promise.all(batches);
                console.log(`Успешно удалено ${docs.length} сообщений`);
            }
            catch (error) {
                console.error("Ошибка при массовом удалении:", error);
                throw error;
            }
        });
    },
    deleteChat(currentUser, selectedChat) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatCurrentRef = doc(db, currentUser.email, firebasePath.CHATLIST);
            const chatGuestRef = doc(db, selectedChat.email, firebasePath.CHATLIST);
            const chatGuestSnap = yield getDoc(chatGuestRef);
            yield updateDoc(chatCurrentRef, {
                [selectedChat.uid]: deleteField()
            });
            if (!(selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel) && chatGuestSnap.exists() && !createChatList(chatGuestSnap.data()).some(item => item.chatID === selectedChat.chatID)) {
                yield deleteDoc(doc(db, firebasePath.CHATS, selectedChat.chatID));
            }
            if (selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel) {
                yield channelAPI.changeListSubscribers(clickType.REMOVE_FROM_LIST_SUBSCRIBERS, selectedChat.channel.channelID, currentUser);
            }
        });
    },
    addToFavorites(currentUser, message) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const favoritesCollectionRef = getChatType(true, currentUser);
            const date = JSON.stringify(new Date());
            const id = uuidv4();
            const messageObj = {
                sender: currentUser,
                message: message.message,
                messageID: id,
                date,
                forwardedFrom: ((_a = message.sender) === null || _a === void 0 ? void 0 : _a.channel) ? createObjectChannel(message.sender.channel) : message.sender
            };
            if (message === null || message === void 0 ? void 0 : message.forwardedFrom) {
                messageObj.forwardedFrom = message.forwardedFrom.channel ?
                    createObjectChannel(message.forwardedFrom.channel)
                    :
                        createObjectUser(message.forwardedFrom);
            }
            if (message === null || message === void 0 ? void 0 : message.shareChat)
                messageObj.shareChat = message.shareChat;
            const messageDocRef = doc(favoritesCollectionRef, id);
            yield setDoc(messageDocRef, messageObj, { merge: true });
        });
    },
    sendCallInfoMessage(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const date = JSON.stringify(new Date());
            const messagesCollectionRef = getChatType(false, options.callee);
            const messageID = uuidv4();
            const isRead = (options === null || options === void 0 ? void 0 : options.callDuration) !== '0:00';
            const messageObj = {
                message: options.callDuration,
                messageID,
                date,
                sender: Object.assign({}, options.caller),
                read: isRead,
                callStatus: options.status
            };
            const messageDocRef = doc(messagesCollectionRef, messageID);
            yield setDoc(messageDocRef, messageObj, { merge: true });
            yield messagesAPI.addChat(options.caller, options.callee, options.callee.chatID);
            yield messagesAPI.addChat(options.callee, options.caller, options.callee.chatID);
        });
    },
    setReaction({ reaction, chat, isMine, messageID, isFavorites }) {
        return __awaiter(this, void 0, void 0, function* () {
            const messagesCollectionRef = getChatType(isFavorites, chat);
            const messageDocRef = doc(messagesCollectionRef, messageID);
            //транзакцию для безопасного атомарного обновления массива реакций
            try {
                yield runTransaction(db, (transaction) => __awaiter(this, void 0, void 0, function* () {
                    const messageSnap = yield transaction.get(messageDocRef);
                    if (!messageSnap.exists()) {
                        throw new Error("Сообщение не найдено для установки реакции.");
                    }
                    const currentMessage = messageSnap.data();
                    let currentReactions = currentMessage.reactions || [];
                    const senderUid = reaction.sender.uid;
                    const reactionsWithoutCurrentSender = currentReactions.filter(item => item.sender.uid !== senderUid);
                    let updatedReactions;
                    if (!isMine) {
                        updatedReactions = [...reactionsWithoutCurrentSender, reaction];
                    }
                    else {
                        updatedReactions = reactionsWithoutCurrentSender;
                    }
                    transaction.update(messageDocRef, {
                        reactions: updatedReactions
                    });
                }));
            }
            catch (error) {
                console.error("Ошибка при установке/удалении реакции в транзакции:", error);
                throw error;
            }
        });
    }
};
export const contactsAPI = {
    addToContacts(currentUser, newContact) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setDoc(doc(db, currentUser, firebasePath.CONTACTS), { [newContact.uid]: newContact }, { merge: true });
        });
    },
    removeFromContacts(currentUser, contact) {
        return __awaiter(this, void 0, void 0, function* () {
            const contactsRef = doc(db, currentUser, firebasePath.CONTACTS);
            yield updateDoc(contactsRef, {
                [contact.uid]: deleteField()
            });
        });
    },
    addToBlacklist(currentUser, contact) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setDoc(doc(db, currentUser, firebasePath.BLACKLIST), { [contact.uid]: contact }, { merge: true });
        });
    },
    removeFromBlacklist(currentUser, contact) {
        return __awaiter(this, void 0, void 0, function* () {
            const contactsRef = doc(db, currentUser, firebasePath.BLACKLIST);
            yield updateDoc(contactsRef, {
                [contact.uid]: deleteField()
            });
        });
    },
    changeContact(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { myEmail, contact } = options;
            const ref = doc(db, myEmail, firebasePath.CONTACTS);
            yield updateDoc(ref, {
                [contact.uid]: contact
            });
        });
    }
};
export const channelAPI = {
    createChannel(owner, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const channelID = uuidv4();
            const dateOfChange = JSON.stringify(new Date());
            const info = {
                owner,
                displayName: data.displayName,
                isOpen: data.isOpen,
                channelID,
                registrationDate: new Date().toLocaleDateString(),
                dateOfChange
            };
            yield setDoc(doc(db, firebasePath.CHANNELS, channelID), {});
            yield setDoc(doc(db, firebasePath.CHANNELS_INFO, channelID), info);
            yield messagesAPI.addChat(owner, createObjectChannel(info));
            return info;
        });
    },
    checkName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = query(collection(db, firebasePath.CHANNELS_INFO), where("displayName", "==", name));
            const querySnapshot = yield getDocs(q);
            const isFree = !Boolean(querySnapshot.size);
            return isFree;
        });
    },
    getCurrentInfo(channelID) {
        return __awaiter(this, void 0, void 0, function* () {
            const channelRef = doc(db, firebasePath.CHANNELS_INFO, channelID);
            const docSnap = yield getDoc(channelRef);
            if (docSnap.exists()) {
                const info = convertBackChannelToClient(docSnap.data());
                const owner = yield profileAPI.getCurrentInfo(info.owner.uid);
                return (Object.assign(Object.assign({}, info), { owner }));
            }
            else {
                return null;
            }
        });
    },
    changeListSubscribers(typeChange, channelID, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, firebasePath.CHANNELS_INFO, channelID);
            const toObjSubscriber = createObjectUser(user);
            if (typeChange === clickType.ADD_TO_LIST_SUBSCRIBERS) {
                yield updateDoc(ref, {
                    [`listOfSubscribers.${user.uid}`]: toObjSubscriber
                });
            }
            if (typeChange === clickType.REMOVE_FROM_LIST_SUBSCRIBERS) {
                const channelRef = doc(db, toObjSubscriber.email, firebasePath.CHATLIST);
                yield updateDoc(ref, {
                    [`listOfSubscribers.${user.uid}`]: deleteField()
                });
                yield updateDoc(channelRef, {
                    [channelID]: deleteField()
                });
            }
        });
    },
    changeCannelInfo(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const channelRef = doc(db, firebasePath.CHANNELS_INFO, options.channel.channelID);
            const dateOfChange = JSON.stringify(new Date());
            const obj = {};
            if (options.updateLastMessage) {
                obj.lastMessage = createBaseMessageObject(options.lastMessage);
            }
            if (options.updateDateOfChange) {
                obj.dateOfChange = dateOfChange;
            }
            else {
                obj.photoURL = options.channel.photoURL;
                obj.displayName = options.channel.displayName;
            }
            yield updateDoc(channelRef, obj);
        });
    },
    deleteChannel(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const infoChannelRef = doc(db, firebasePath.CHANNELS_INFO, id);
            const channelRef = doc(db, firebasePath.CHANNELS, id);
            return Promise.all([deleteDoc(infoChannelRef), deleteDoc(channelRef)]);
        });
    },
    applyForMembership(user, channelID) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, firebasePath.CHANNELS_INFO, channelID);
            const list = yield getDoc(ref);
            if (list.exists()) {
                const info = list.data();
                const targetUser = (_a = info.applyForMembership) === null || _a === void 0 ? void 0 : _a.find(item => item.uid === user.uid);
                if (targetUser)
                    return;
                else {
                    yield updateDoc(ref, {
                        applyForMembership: arrayUnion(user)
                    });
                }
            }
        });
    },
    getApplyForMembership(channelID) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, firebasePath.CHANNELS_INFO, channelID);
            const list = yield getDoc(ref);
            if (list.exists()) {
                const info = list.data();
                return info.applyForMembership || [];
            }
        });
    },
    deleteApplication(channelID, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, firebasePath.CHANNELS_INFO, channelID);
            yield updateDoc(ref, {
                applyForMembership: arrayRemove(user)
            });
        });
    },
    changeAccessChannel(channelID, action) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, firebasePath.CHANNELS_INFO, channelID);
            yield updateDoc(ref, {
                isOpen: action
            });
        });
    },
    updateChannelInMyChatList(email, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = doc(db, email, firebasePath.CHATLIST);
            yield setDoc(ref, { [channel.channel.channelID]: channel }, { merge: true });
        });
    }
};
